import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import { issueProductEntry, readEntryChallenge } from '../services/productEntry';

export default function EcommerceEntry() {
  const { isAuthenticated } = useTenant();
  const location = useLocation(); const [error, setError] = useState(''); const started = useRef(false);
  useEffect(() => {
    if (!isAuthenticated || started.current) return;
    started.current = true;
    let payload;
    try { payload = readEntryChallenge(location.search); }
    catch (failure) { setError(failure.message); return; }
    issueProductEntry(payload).then((url) => window.location.replace(url)).catch((failure) => setError(failure.message));
  }, [isAuthenticated, location.search]);
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ ecommerceEntryReturn: `/ecommerce-entry${location.search}` }} />;
  return <main style={{ padding: '2rem', maxWidth: '40rem', margin: 'auto' }}><h1>进入电商工作区</h1>{error ? <><p role="alert">{error}</p><a href="/login">返回统一登录</a></> : <p role="status">正在验证账号，请稍候…</p>}</main>;
}
